import * as tslib_1 from "tslib";
import { AbstractPageComponent } from "src/app/shared/components/abstract-page/abstract-page.component";
var ContentComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ContentComponent, _super);
    function ContentComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTitle = "Content page";
        return _this;
    }
    return ContentComponent;
}(AbstractPageComponent));
export { ContentComponent };
